import type { IconData } from '@stacksjs/iconify-core'

export const otherUiSend: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 4l16-4l-4 16l-4-4l-4 4v-5l4.94-4.94L7.878 5l-3.44 3.44z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiSend
